import { render, staticRenderFns } from "./ElraReport8Assistant.vue?vue&type=template&id=60a41d79"
import script from "./ElraReport8Assistant.vue?vue&type=script&lang=ts"
export * from "./ElraReport8Assistant.vue?vue&type=script&lang=ts"
import style0 from "./ElraReport8Assistant.vue?vue&type=style&index=0&id=60a41d79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports